import moment from 'moment';
moment.locale('nb');

import * as React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';

import { GET_PROPERTY_VIEWINGS_QUERY } from '../../../../../client/__graphql__/queries/getPropertyViewing';

import {
  GetPropertyViewings,
  GetPropertyViewingsVariables,
} from '../../../../__types__/generated/GetPropertyViewings';

import { TileViewing as Tile } from './Tile';
import { Button } from '../../../ui/Button';
import styled from 'styled-components';

export const TileViewing: React.FC<{ className?: string }> = ({
  className,
}) => {
  const params = useParams<{ sguid: string }>();
  const history = useHistory();

  const { data } = useQuery<GetPropertyViewings, GetPropertyViewingsVariables>(
    GET_PROPERTY_VIEWINGS_QUERY,
    {
      fetchPolicy: 'cache-only',
      variables: { input: { sguid: params.sguid } },
    }
  );

  return (
    <StyledTile
      className={className}
      onClick={() => {
        window.location.href = `https://privatmegleren.no/${params.sguid}/visningspaamelding`;
      }}
    >
      <span className="title">Visning</span>
      {data?.getProperty?.viewings?.list &&
      data?.getProperty?.viewings?.list?.length > 0 ? (
        data?.getProperty?.viewings?.list?.map((item, index) => {
          if (index === 0) {
            const format = 'DD.MM.YYYY HH:mm';
            const date = item?.from
              ? moment(item.from, format).format('dddd DD.MM')
              : '';
            const from = item?.from
              ? moment(item.from, format).format('HH:mm')
              : '';
            const to = item?.to
              ? moment(item.to, 'DD.MM.YYYY HH:mm').format('HH:mm')
              : '';
            return (
              <div className="viewing-item" key={item?.id}>
                <span className="day">{date}</span>
                <span className="time">
                  {from} - {to}
                </span>
              </div>
            );
          }
          return null;
        })
      ) : (
        <>
          <span className="by-appointment">Etter avtale!</span>
        </>
      )}
      <div style={{ marginTop: '10px' }}>
        <Button variant="outline" colorVariant="primary">
          Meld på visning
        </Button>
      </div>
    </StyledTile>
  );
};

const StyledTile = styled(Tile)`
  @media all and (max-width: 960px) {
    padding: 20px 40px;
  }
`;
